import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo-transparent.png";

function FooterComponent() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-line bg-white/75 backdrop-blur">
      <div className="mx-auto flex w-full max-w-site flex-col gap-6 px-4 py-8 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-4">
            <div className="flex h-14 w-14 items-center justify-center rounded-full border border-brand/20 bg-white shadow-soft">
              <img
                src={logo}
                alt="Logo Sofiane Amroune"
                className="h-10 w-10 object-contain"
              />
            </div>
            <div>
              <p className="text-base font-semibold text-ink">Sofiane Amroune</p>
            </div>
          </div>

          <div className="flex flex-wrap gap-4 text-sm">
            <Link
              to="/mentions-legales"
              className="content-link focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
            >
              Mentions légales
            </Link>
            <Link
              to="/politique-de-confidentialite"
              className="content-link focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
            >
              Politique de confidentialité
            </Link>
          </div>
        </div>

        <div className="border-t border-line pt-4">
          <p className="text-sm text-muted">
            &copy; {currentYear} Sofiane Amroune. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default FooterComponent;
